"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TestComponent = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TestComponent = exports.TestComponent = function TestComponent(_ref) {
  var text = _ref.text,
    subtext = _ref.subtext;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", null, text), subtext ? /*#__PURE__*/_react["default"].createElement("div", null, subtext) : null);
};